import * as yup from 'yup'
import { isConsultaBA, limparFiltrosConsultaBA } from './consultaBA'

export const schema = yup
    .object({
        baseConsulta: yup
            .string()
            .required('O campo Base de consulta é obrigatório'),

        ufContrato: yup
            .string()
            .required('O campo UF do Contrato é obrigatório'),

        dataEnvioInicial: yup.string().when('ufContrato', {
            is: (uf: string) => ['MT', 'TO'].includes(uf),
            then: schema =>
                schema.required(
                    'O campo Período de envio inicial é obrigatório para a UF selecionada'
                ),
            otherwise: schema => schema.optional().nullable()
        }),

        dataEnvioFinal: yup
            .mixed<string>()
            .concat(yup.date())
            .transform((curr, orig) => (orig === '' ? null : curr))
            .nullable(),

        chassi: yup
            .string()
            .transform(v => (v ? String(v).trim() : v))
            .when(['baseConsulta', 'ufContrato'], {
                is: isConsultaBA,
                then: schema =>
                    schema.max(21, 'Chassi deve ter no máximo 21 caracteres'),
                otherwise: schema =>
                    schema.max(25, 'Chassi deve ter no máximo 25 caracteres')
            })
            .when(['baseConsulta', 'ufContrato'], {
                is: (baseConsulta: string, uf: string) =>
                    baseConsulta === 'SNG' || !['PR', 'MT', 'ES'].includes(uf),
                then: schema => schema.required('O campo Chassi é obrigatório'),
                otherwise: schema => schema.optional()
            }),

        cnpjAgenteFinanceiro: yup
            .string()
            .transform(v => (v ? String(v).trim() : v))
            .when(['baseConsulta', 'ufContrato'], {
                is: (baseConsulta: string, uf: string) =>
                    baseConsulta === 'SNG' || !['PR', 'BA'].includes(uf),
                then: schema => schema.required('O campo CNPJ é obrigatório'),
                otherwise: schema => schema.optional()
            })
            .when(['baseConsulta', 'ufContrato'], {
                is: isConsultaBA,
                then: schema =>
                    schema.test(
                        'cnpj-length',
                        'CNPJ deve conter 14 dígitos',
                        value =>
                            !value || value.replace(/\D/g, '').length === 14
                    )
            }),

        numeroContrato: yup
            .string()
            .transform(v => (v ? String(v).trim() : v))
            .when(['baseConsulta', 'ufContrato'], {
                is: (baseConsulta: string, uf: string) =>
                    baseConsulta === 'SNG' || !['ES', 'BA'].includes(uf),
                then: schema =>
                    schema.required('O campo Nº Contrato é obrigatório'),
                otherwise: schema => schema.optional()
            })
            .when(['baseConsulta', 'ufContrato'], {
                is: isConsultaBA,
                then: schema =>
                    schema.max(
                        20,
                        'Nº Contrato deve ter no máximo 20 caracteres'
                    )
            }),

        numeroAditivo: yup.string(),

        numeroGravame: yup.string(),
        numeroRestricao: yup.string(),

        numeroDuda: yup.string().when('ufContrato', {
            is: 'RJ',
            then: schema =>
                schema.required('Nº do Duda é obrigatório para a UF RJ'),
            otherwise: schema => schema.optional()
        }),

        numeroIdRegistro: yup.string(),
        tipoPesquisa: yup.string(),
        placa: yup.string(),

        cpfCnpjDevedor: yup
            .string()
            .transform(v => (v ? String(v).trim() : v))
            .when('ufContrato', {
                is: (uf: string) => uf === 'RS',
                then: schema =>
                    schema
                        .required('Campo obrigatório')
                        .test(
                            'cpf-cnpj-length',
                            'CPF/CNPJ deve conter 11 ou 14 dígitos',
                            value => {
                                const digits = (value ?? '').replace(/\D/g, '')
                                return (
                                    digits.length === 11 || digits.length === 14
                                )
                            }
                        ),
                otherwise: schema =>
                    schema.test(
                        'cpf-cnpj-length',
                        'CPF/CNPJ deve conter 11 ou 14 dígitos',
                        value => {
                            if (!value) return true
                            const digits = value.replace(/\D/g, '')
                            return digits.length === 11 || digits.length === 14
                        }
                    )
            }),

        tipoRestricao: yup
            .string()
            .transform(v => (v ? String(v).trim() : v))
            .when('ufContrato', {
                is: (uf: string) => uf === 'RS',
                then: schema => schema.required('Campo obrigatório'),
                otherwise: schema => schema.optional()
            })
    })
    .transform(limparFiltrosConsultaBA)
